import { useRef, useState } from "react";
import { Checkbox, Divider, FormControlLabel, FormGroup, Grid } from "@mui/material";
import { useAutoAnimate } from "@formkit/auto-animate/react";

//import constants
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import images and icons
import { ArrowDown2, Stop, TickSquare } from "iconsax-react";

//import styles
import "./order-details-modal.scss";

function OrderRooms({ orderItem, isCancellationRequest }) {
    //general variables
    const [parent] = useAutoAnimate();

    //Accordion to display the passengers of each room
    const contentHeight = useRef();
    const [activeIndex, setActiveIndex] = useState(null);
    const handleItemClick = index => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };

    return (
        <Grid container item xs={12} rowGap={1} justifyContent="center" mb={2}>
            {orderItem?.rooms?.map((room, index) => {
                return (
                    <>
                        <Grid container item xs={12} rowGap={1} justifyContent="space-between" alignItems="center">
                            <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                <FormGroup sx={{ width: "100%" }}>
                                    <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                                        {isCancellationRequest ? (
                                            <Grid container item xs={9}>
                                                <FormControlLabel
                                                    key={room?.id}
                                                    control={
                                                        <Checkbox
                                                            icon={<Stop size={IS_MOBILE ? "22" : "24"} color="var(--teal-color-18)" />}
                                                            checkedIcon={
                                                                <TickSquare
                                                                    size={IS_MOBILE ? "22" : "24"}
                                                                    color="var(--secondary-color)"
                                                                    variant="Bold"
                                                                />
                                                            }
                                                            name={`${room?.id}`}
                                                            // checked={selectedPassenger[passenger?.id]}
                                                            // onChange={handleChange}
                                                            disabled={room?.canceled?.key !== 0}
                                                        />
                                                    }
                                                    label={
                                                        <Grid component="span" className="order-details-modal__room-name" container item xs={12}>
                                                            {room?.name}
                                                        </Grid>
                                                    }
                                                />
                                            </Grid>
                                        ) : (
                                            <Grid className="order-details-modal__room-name" container item xs={9} ref={parent}>
                                                {room?.name}
                                            </Grid>
                                        )}
                                        <Grid container item xs={3} columnGap={1} justifyContent="flex-end" alignItems="center">
                                            <Grid
                                                className={`order-details-modal__canceled${room?.canceled?.key}`}
                                                container
                                                item
                                                xs={8}
                                                justifyContent="center"
                                                alignItems="center"
                                            >
                                                {room?.canceled?.value}
                                            </Grid>
                                            <ArrowDown2
                                                className={`order-details-modal__arrow ${activeIndex === index ? "active" : ""}`}
                                                onClick={() => handleItemClick(index)}
                                                color="var(--primary-color)"
                                                size={20}
                                                cursor="pointer"
                                            />
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </Grid>

                            <Grid className="order-details-modal__passengers" container item xs={12}>
                                <Grid
                                    ref={contentHeight}
                                    className="order-details-modal__passenger-container"
                                    style={activeIndex === index ? { height: contentHeight.current.scrollHeight } : { height: "0px" }}
                                    container
                                    item
                                    xs={12}
                                    rowGap={1}
                                    alignItems="flex-start"
                                >
                                    {room.passengers.map(passenger => {
                                        return (
                                            <Grid className="order-details-modal__passenger" container item xs={12} justifyContent="space-between">
                                                <span>
                                                    {passenger?.first_name} {passenger?.last_name}
                                                </span>
                                                <span>{passenger?.national_id}</span>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider width="100%" sx={{ borderBottomColor: "var(--medium-gray-color)" }} />
                    </>
                );
            })}
        </Grid>
    );
}

export default OrderRooms;
